import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import SEO from "@/components/SEO";

const SECTIONS = [
  { t: "Information we collect",
    d: "We collect personal information you provide via our forms (name, email, phone, address details), files you upload (images, documents, videos), and information about your interactions with our service." },
  { t: "How we use your information",
    d: "We use your information to provide the support, quote review and insurance guidance services you've requested, to manage your membership, to communicate with you, and to comply with legal obligations." },
  { t: "Sharing your information",
    d: "We share data with payment processors (Stripe), email service providers (Resend), and trusted contractors only with your consent. We do not sell your data." },
  { t: "Data retention",
    d: "Member records are retained for the duration of your membership plus 7 years for accounting purposes. Uploaded files supporting closed cases are retained for 3 years unless you request deletion." },
  { t: "Your rights",
    d: "Under UK data protection law you have the right to access, correct, delete, restrict or object to the processing of your personal data, and the right to data portability. Contact us at advice@parkhomesupport.co.uk to exercise these rights." },
  { t: "Cookies",
    d: "We use essential cookies to keep the site working. We may use anonymous analytics to improve the service." },
  { t: "Contact",
    d: "Questions about this policy? Email advice@parkhomesupport.co.uk." },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <SEO
        title="Privacy Policy | Park Home Support"
        description="How Park Home Support collects, uses and protects your personal information."
        canonical="https://parkhomesupport.co.uk/privacy"
      />
      <section className="bg-[#F7F4ED] section-pad">
        <div className="container-phs max-w-3xl">
          <span className="eyebrow">Privacy Policy</span>
          <h1 className="font-display text-4xl sm:text-5xl mt-3 text-[#071A33]">How we handle your data.</h1>
          <p className="mt-5 text-[#334155]">Last updated: {new Date().toLocaleDateString("en-GB", { year: "numeric", month: "long" })}</p>
        </div>
      </section>
      <section className="section-pad bg-white">
        <div className="container-phs max-w-3xl">
          <Accordion type="single" collapsible className="w-full">
            {SECTIONS.map((s, i) => (
              <AccordionItem key={s.t} value={`item-${i}`} className="border-b border-[#E2DCD0]">
                <AccordionTrigger className="text-left font-display text-xl text-[#071A33] py-5" data-testid={`privacy-acc-${i}`}>{s.t}</AccordionTrigger>
                <AccordionContent className="text-[#334155] pb-5 leading-relaxed">{s.d}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
